<template>
	<div style="height: 100%;">
		<div style="height: 100%;">
			<div class="title-top">
				<img src="../../../../static/imgV2/detail-title.png" alt="">
				<div class="title-top-text">{{ languageJson.mapAndRoutes }}</div>
			</div>
			<div class="fls" v-if="mapRobotInfo.robotType != '08'">
				<div style="display: flex;align-items: center;justify-content: center;">
					<span style="margin-right: 5px;">{{ languageJson.PatrolMap }}</span>
					<span style="width: 50%;">
						<marquee :val="mapInfo.mapName"></marquee>
					</span>
				</div>
				<div style="display: flex;align-items: center;justify-content: center;">
					<span style="margin-right: 5px;">{{ languageJson.PatrolRoute }}</span>
					<span style="width: 50%;">
						<marquee v-if="robotStstus != '0'" :val="lineNames"></marquee>
					</span>
				</div>
			</div>
			<div class="flbj" v-else-if="mapRobotInfo.robotType == '08'">
				<span>{{ languageJson.PatrolMap }}</span>
				<span>{{ mapInfo.mapName }}</span>
			</div>
			<div class="flbj" v-if="mapInfo.floorName">
				<span>{{ languageJson.CurrentFloor }}</span>
				<span>{{ mapInfo.floorName }}</span>
			</div>
			<div v-else style="height: 30px;"></div>
			<div ref="autoHeight" style="width: 100%;height: calc(100% - 110px);cursor: pointer;overflow: hidden;" @click="openMap()">
				<RobotMapLiInfo v-if="mapRobotInfo.robotType == '04' || mapRobotInfo.robotType == '05' || mapRobotInfo.robotType == '06' || mapRobotInfo.robotType == '07'" :changeTime='changeTime' :position="mapRobotInfo" :posInfo='posInfo' :autoHeight="mapHeight" :autoWidth="mapWidth" />
				<RobotMapLi v-else :position="mapRobotInfo" :posInfo='posInfo' :autoHeight="mapHeight" :autoWidth="mapWidth" />
			</div>
		</div>
	</div>
</template>

<script>
	import RobotMapLi from '@/components/RobotMapLi1.vue'
	import RobotMapLiInfo from '@/components/RobotMapLiInfo.vue'
	import marquee from '@/components/marquee.vue'
	import {
		mapRoute
	} from '@/api/indexV2'
	export default {
		name: '',
		data() {
			return {
				languageJson: languageJson,
				mapHeight: 0,
				mapWidth: 0,
				lineNames: "",
				mapRobotInfo: {},
				changeTime: 0,
				robotStstus: '1'
			}
		},
		props: {
			mapInfo: null,
			robotInfo: null,
			posInfo: null
		},
		components: {
			RobotMapLi,
			RobotMapLiInfo,
			marquee
		},
		mounted() {
			let that = this
			that.mapHeight = that.$refs.autoHeight.offsetHeight
			that.mapWidth = that.$refs.autoHeight.offsetWidth
			window.onresize = function () {
				that.mapHeight = that.$refs.autoHeight.offsetHeight
				that.mapWidth = that.$refs.autoHeight.offsetWidth
			}
		},
		methods: {
			openMap() {
				this.$emit('openMap',true)
			}
		},
		watch: {
			posInfo: {
				immediate: true,
				handler(newValue, oldValue) {
					if (newValue) {
						this.robotStstus = newValue.ststus
					}
				}
			},
			robotInfo: {
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					that.mapRobotInfo = newValue
					setTimeout(() => {
						that.mapHeight += 1
						that.mapWidth += 1
					}, 500)
				}
			},
			mapInfo: {
				immediate: true,
				handler(newValue, oldValue) {
					if (newValue.lineNames && newValue.lineNames.length > 0) {
						this.lineNames = newValue.lineNames.toString()
						this.changeTime = new Date().getTime();
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.title-top {
		display: flex;
		color: #fff;
		font-size: 0.8vw;
		align-items: center;
		justify-content: flex-start;
		margin: 0.5vw;
		padding-top: 0.5vw;
		padding-bottom: 0.3vw;
		border-bottom: 1px solid rgba(0, 240, 255, 0.1);
		&-text {
			text-shadow: 0 0 10px rgba(0, 240, 255, 0.4);
			background: linear-gradient(180deg, #FFFFFF 0%, #00e0ff 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			font-weight: bold;
			color: #FFFFFF;
			letter-spacing: 2px;
		}

		img {
			width: 1vw;
			margin-right: 0.3vw;
			filter: drop-shadow(0 0 4px rgba(0, 240, 255, 0.5));
		}
	}

	.fls {
		display: flex;
		color: #fff;
		line-height: 2vw;
		font-size: 0.75vw;

		>div:nth-child(1) {
			flex: 1;
			height: 2vw;
			background: linear-gradient(90deg, rgba(0, 40, 100, 0.4), rgba(0, 15, 50, 0.15));
			border-left: 2px solid rgba(0, 240, 255, 0.35);
			border-radius: 0 4px 4px 0;
			padding-left: 0.4vw;

			>span:nth-child(1) {
				color: rgba(180, 220, 255, 0.7);
				font-size: 0.7vw;
			}

			>span:nth-child(2) {
				color: #00f0ff;
				text-shadow: 0 0 6px rgba(0, 240, 255, 0.3);
				font-weight: 600;
			}

			margin: 0 6px 0 12px;
			transition: all 0.3s ease;
		}

		>div:nth-child(2) {
			margin: 0 12px 0 6px;
			flex: 1;
			height: 2vw;
			background: linear-gradient(90deg, rgba(0, 40, 100, 0.4), rgba(0, 15, 50, 0.15));
			border-left: 2px solid rgba(0, 240, 255, 0.35);
			border-radius: 0 4px 4px 0;
			padding-left: 0.4vw;

			>span:nth-child(1) {
				color: rgba(180, 220, 255, 0.7);
				font-size: 0.7vw;
			}

			>span:nth-child(2) {
				color: #00f0ff;
				text-shadow: 0 0 6px rgba(0, 240, 255, 0.3);
				font-weight: 600;
			}
			transition: all 0.3s ease;
		}
	}

	.flbj {
		height: 2vw;
		line-height: 2vw;
		background: linear-gradient(90deg, rgba(0, 40, 100, 0.4), rgba(0, 15, 50, 0.15));
		border-left: 2px solid rgba(0, 200, 255, 0.4);
		border-radius: 0 4px 4px 0;
		padding-left: 0.5vw;
		margin: 12px;
		font-size: 0.8vw;
		transition: all 0.3s ease;

		>span:nth-child(1) {
			color: rgba(180, 220, 255, 0.7);
		}

		>span:nth-child(2) {
			color: #00f0ff;
			text-shadow: 0 0 6px rgba(0, 240, 255, 0.3);
			font-weight: 600;
		}
	}

	.imgs {
		margin: 12px;

		>img {
			width: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/robotDetail/components/bottomLeft.vue